"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractDataFromUrlQuery = void 0;
const extractDataFromUrlQuery = (url) => {
    var _a, _b, _c, _d, _e;
    const searchParams = new URLSearchParams(url.split('?')[1] || '');
    const trackingParams = {
        urlId: (_a = searchParams.get('urlid')) !== null && _a !== void 0 ? _a : searchParams.get('urlId'),
        urlName: (_c = (_b = searchParams.get('urlname')) !== null && _b !== void 0 ? _b : searchParams.get('urlName')) !== null && _c !== void 0 ? _c : 'messagecenter-open',
        partnerId: (_d = searchParams.get('partnerid')) !== null && _d !== void 0 ? _d : searchParams.get('partnerId'),
        utmCampaign: (_e = searchParams.get('utm_campaign')) !== null && _e !== void 0 ? _e : '',
    };
    return trackingParams;
};
exports.extractDataFromUrlQuery = extractDataFromUrlQuery;
